import { sortBy } from 'lodash';

export default {
  getBrand: (state) => state.brand,
  brands: (state) => sortBy(state.brands, 'name'),
};
